import React, { useEffect } from 'react'
import { tokenKey, getToken } from '@/utils/user'
import { checkLoginStatus } from '@/business/login'
import useUpdateEffect from 'ahooks/es/useUpdateEffect'
import { getWsDomain } from '@/servers/config'
import { WebSocketClient } from './new'
import { useNetwork, useLocalStorageState } from 'ahooks/es'
import { wsEvent } from './event'

const SOCKET_SERVER_URL = getWsDomain()

export const useSocket = () => {
  const socketInstRef = React.useRef<WebSocketClient | null>(null)
  const networkState = useNetwork()

  const [refreshMark, setRefreshMark] = useLocalStorageState<number>('yt_refreshMark', {
    defaultValue: 0
  })

  const initWsUrl = () => {
    const token = getToken()
    const params = {
      [tokenKey]: token
    }
    const searchParam = new URLSearchParams(params)
    return SOCKET_SERVER_URL + '?' + searchParam
  }

  const handlerMsg = (data: any) => {
    if (data?.type) {
      wsEvent.dispatchEvent(data.type, data)
    }
  }

  const initSocket = async () => {
    if (!window?.WebSocket) {
      return
    }

    const loginStatus = await checkLoginStatus()
    if (!loginStatus) return

    const ws = new WebSocketClient(initWsUrl())
    socketInstRef.current = ws

    ws.onmessage(msg => {
      handlerMsg(msg)
    })
    ws.onopen(() => {
      socketInstRef.current = ws
    })
    return ws
  }

  useEffect(() => {
    initSocket()
    return () => {
      socketInstRef.current?.close()
    }
  }, [])

  useUpdateEffect(() => {
    if (!networkState.online) {
      socketInstRef.current?.close()
    } else {
      if (!refreshMark || refreshMark <= 0) {
        // 网络恢复时通过刷新页面重建 WS 连接
        setRefreshMark(1)
        window.location.reload()
      } else {
        setTimeout(() => {
          setRefreshMark(0)
        }, 1000 * 60)
      }
    }
  }, [networkState.online])

  return {
    ytWebScketRef: socketInstRef
  }
}
